export const CONTAINER_ID = 'game-html-overlay';
